import { render } from "./FooterUniversiteitgent.vue?vue&type=template&id=62d3fbea&scoped=true"
import script from "./FooterUniversiteitgent.vue?vue&type=script&lang=js"
export * from "./FooterUniversiteitgent.vue?vue&type=script&lang=js"

import "./FooterUniversiteitgent.vue?vue&type=style&index=0&id=62d3fbea&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d3fbea"]])

export default __exports__